var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01266 0.307026H15.3996L10.4738 16.8692C10.1281 18.0311 10.8616 18.9893 12.0701 18.9893C13.279 18.9893 14.5235 18.0311 14.8688 16.8692L19.7947 0.307026L28.1186 0.306824L22.431 21.4786C21.929 23.3461 19.9341 24.8747 17.9978 24.8747H3.59625C1.29513 24.8747 -0.0996885 23.0587 0.49677 20.8381L6.01266 0.307026Z",
    fill: "#FA4031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5595 9.35419V9.35439H48.199L46.448 15.089H36.8051L34.1283 24.875H25.0659L29.4971 9.35419H38.5595Z",
    fill: "#FA4031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3145 0.0584106H69.5737C71.367 0.0584106 74.411 1.49522 73.7881 3.78013L73.5426 4.67974H62.6031C62.0412 4.67974 61.4565 5.13033 61.3046 5.68075L57.9047 17.9925C57.7528 18.5431 58.0882 18.9934 58.6502 18.9934H69.6395L68.8427 21.9149C68.3815 23.6075 66.5629 24.9998 64.7705 24.9998H51.8284C49.5473 24.9998 48.1459 23.2334 48.7144 21.0752L53.4876 2.95679C53.9075 1.3625 55.6296 0.0584106 57.3145 0.0584106Z",
    fill: "#FA4031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1664 6.00713H39.5466L39.5418 6.02366H30.4795L32.223 -0.000183105C38.4494 -0.000183105 44.6759 -0.000183105 50.9019 -0.000183105L49.1664 6.00713Z",
    fill: "#FA4031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.5123,
    height: 25,
    fill: "white",
    transform: "translate(0.358887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfc);
export default __webpack_public_path__ + "static/media/ufc.2517cdbe1b8f0d3b6a03c0523980e423.svg";
export { ForwardRef as ReactComponent };